<script lang="ts">
	import Icon from '@smui/common/CommonIcon.svelte';
	import Text from '../Text.svelte';

	export let runId: string;
	export let runStatus: string;
</script>

<div class="try-again-box">
	<Icon class="material-icons">info</Icon>
	<!--<Text type="body1">Please be patient, we are starting our cluster</Text>-->
	<!--<Text type="body1">It takes usually about 10 minutes.</Text>-->
	<!--{#if finishEstimate}
        <Text type="body1">
            Computation should be finished around
            <b>{finishEstimate.format('HH:mm:ss')}</b>
        </Text>
    {/if}-->
	<!--<Text type="body1">Click following button to to check its' status again</Text>-->
	<Text>There was a problem during generating the targeting list.</Text>
	<div class="try-again-techinfo">
		<Text>
			run ID:
			<b>{runId}</b>
		</Text>
		<Text>
			run status:
			<b>{runStatus}</b>
		</Text>
	</div>
	<!--<Button variant="outlined" on:click inline={false}>Check again for result</Button>-->
</div>

<style>
	.try-again-box {
		border: 1px solid var(--mdc-theme-primary);
		border-radius: 6px;
		max-width: 400px;
		margin: 26px auto;
		padding: 0 10px 20px;
		text-align: center;
	}

	.try-again-box :global(.material-icons) {
		color: var(--mdc-theme-primary);
		margin: 15px auto;
	}

	.try-again-techinfo {
		margin: 16px 0;
	}
</style>
